import styled from "styled-components";

export const Container = styled.div`
  border-radius: 1rem;
  border: 0.1rem solid #2c2c2e80;
  padding: 2rem;
  backdrop-filter: blur(0.5rem);
`;
